import React from "react";
import { makeStyles, Typography, Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

import ProductCartListItem from "./ProductListItemFunnel";
import { FunnelCardContainer } from "ui/funnelCardContainer/FunnelCardContainer";
import useCart from "../../../../../hooks/useCart";
import useWarranty from "../../../../../hooks/useWarranties";
import { formatPriceCents } from "components/product/utils";
import animatedCircle from "../../../assets/animatedCircle.json";

export default function ProductWithWarranty({ product, onDelete, warranty_pk }) {
  const classes = useStyle();
  const [, dispatch] = useCart();

  const warrantyOptions = useWarranty(product.price, product.id);

  const circleAnimationOptions = {
    loop: false,
    animationData: animatedCircle,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  React.useEffect(() => {
    if (warrantyOptions && warrantyOptions.length > 0 && !warranty_pk) {
      const shortestOption = warrantyOptions.sort((a, b) => {
        if (a.years < b.years) return -1;
        return 1;
      })[0];
      updateWarranty(shortestOption.id.toString(), shortestOption.price, shortestOption.years, shortestOption.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warrantyOptions, warranty_pk]);

  const updateWarranty = (value, price, years, name) => {
    dispatch({
      type: "updateWarranty",
      warranty_name: name,
      warranty_pk: value,
      warranty_price: price,
      warranty_years: years,
      product,
    });
  };

  const isOptionSelected = (option) => warranty_pk === option.id.toString();

  return (
    <FunnelCardContainer addBorder>
      <ProductCartListItem product={product} onDelete={onDelete} />
      <Typography color="secondary" className={classes.warrantTitle}>
        Garantie
      </Typography>
      <RadioGroup
        aria-label="gender"
        name="gender1"
        onChange={(ev) =>
          updateWarranty(
            ev.target.value,
            warrantyOptions.find((option) => option.id.toString() === ev.target.value)?.price,
            warrantyOptions.find((option) => option.id.toString() === ev.target.value)?.years,
            warrantyOptions.find((option) => option.id.toString() === ev.target.value)?.name
          )
        }
        className={classes.radioGroup}
      >
        {warrantyOptions?.map((option) => (
          <div key={option.id.toString()} className={classes.warrantyChoice}>
            <FormControlLabel
              value={option.id.toString()}
              control={<Radio color="primary" checked={isOptionSelected(option)} />}
              label={
                <Typography
                  component="span"
                  variant="body2"
                  className={isOptionSelected(option) ? classes.warrantySelected : ""}
                >
                  {`Garantie ${option.years} an${option.years > 1 ? "s" : ""}`}
                </Typography>
              }
            />
            <div className={classes.priceContainer}>
              <Typography component="span" id={option.id.toString()} variant="body2" className={classes.price}>
                {option.price === 0 ? "Offerte" : formatPriceCents(option.price)}
              </Typography>
              <div className={classes.animationContainer}>
                <Lottie
                  options={{ ...circleAnimationOptions, autoplay: isOptionSelected(option) }}
                  height={170}
                  width={170}
                  isClickToPauseDisabled
                  isStopped={!isOptionSelected(option)}
                  Animated={isOptionSelected(option)}
                />
              </div>
            </div>
          </div>
        ))}
      </RadioGroup>
    </FunnelCardContainer>
  );
}

const useStyle = makeStyles((theme) => ({
  radioGroup: {
    "& .MuiFormControlLabel-label": {
      width: "100%",
    },
  },
  warrantTitle: {
    fontWeight: 500,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(),
  },
  warrantyChoice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  warrantySelected: {
    fontWeight: 500,
  },
  priceContainer: {
    position: "relative",
  },
  animationContainer: {
    position: "absolute",
    left: -57,
    top: -77,
  },
}));
